import { Button, Checkbox, Divider, FormControlLabel } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { duplicateShipMobilePage } from "../../utils/ApiCalls/AddShipMobilePage";
import {
  duplicateDailyPlannerPages,
  getTargetedSailing,
  checkPlannerPages,
} from "../../utils/ApiCalls/DailyPlanner";
import { addlog, addBulkLogs } from "../../utils/ApiCalls/Logs";
import { getSailingDate } from "../../utils/ApiCalls/SailingDates";
import { getVessels } from "../../utils/ApiCalls/SpecialPage";
import { checkFields } from "../../utils/Validation/checkFields";
import { DAILY_PLANNER_LOG_TYPES, createPlannerTitle } from "../../constants/logging/dailyPlanner";
import FormPopup from "../FormPopup";

const DailyPlannerDuplicateInput = ({ newsletter }) => {
  const [oldsailingDate, setOldSailingDate] = useState();
  const [sailing_date, setSailingDate] = useState();
  const params = useParams();
  const [vessel_id, setVessel_id] = useState();
  const [displayLocation, setDisplayLocation] = useState([]);
  const [selectedPlanner, setSelectedPlanner] = useState("");
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState();
  const [targetDailyPlanner, setTargetedDailyPlanner] = useState([]);
  const [vesselOptions, setVesselOptions] = useState([]);
  const [sailingOptions, setsailingOptions] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [notMatchedCount, setNotMatchedCount] = useState(0);
  const [notMatchedPages, setNotMatchedPages] = useState([]);
  const navigate = useNavigate();

  const validDates = sailingOptions.map((item) =>
    moment(item.sailing_date).startOf("day")
  );
  useEffect(() => {
    if (newsletter?.id) getOptionLocation();
  }, [newsletter]);

  const compareFromat = (date) => {
    return moment(date).format("DDMMYYYY");
  };
  const proceedWithDuplication = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let added = false;
    let dataValues = {
      sourcePlannerID: newsletter?.id,
      targetPlannerId: selectedPlanner,
    };

    let valid = checkFields(dataValues);
    if (valid) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: valid, type: "error" },
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
      setError(valid);
      return;
    } else {
      setError();

      const values = {
        ...dataValues,
      };

      let data;
      data = await duplicateDailyPlannerPages(values);
      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.message, type: "error" },
        });
        return;
      }

      if (data?.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
        return;
      } else {
        added = true;

        const vesselName = vesselOptions.find(v => v.id === newsletter?.vessel_id)?.name || "Unknown Vessel";
        const sourcePlannerTitle = createPlannerTitle(newsletter?.sailing_date, newsletter?.duration);

        const createDuplicationLogData = (plannerId) => {
          const targetPlanner = targetDailyPlanner.find(p => p.id === plannerId);
          const targetPlannerTitle = createPlannerTitle(targetPlanner?.primarySailingDate, newsletter?.duration);
          return {
            title: `Content duplicated from ${sourcePlannerTitle} to ${targetPlannerTitle}`,
            action: DAILY_PLANNER_LOG_TYPES.ACTION_TYPES.DUPLICATION,
            source_planner: sourcePlannerTitle,
            target_planner: targetPlannerTitle,
            source_planner_id: newsletter?.id,
            target_planner_id: plannerId,
            page_count: newsletter?.page_count,
            vessel_name: vesselName
          };
        };

        if (selectedPlanner) {
          await addlog(
            DAILY_PLANNER_LOG_TYPES.ACTIONS.CONTENT_DUPLICATED,
            DAILY_PLANNER_LOG_TYPES.MODULE,
            createDuplicationLogData(selectedPlanner),
            userDetails.id
          );
        }
      }

      if (added && !newsletter.id) {
        navigate(`/shore/daily-planner/${params.vessel}`);
      } else {
        navigate(`/shore/daily-planner/${params.vessel}`);
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: {
            message: `Daily planner content duplicated successfully`,
            type: "success"
          },
        });
      }
    }
  };
  
  const addNewsLetter = async (e) => {
    e.preventDefault();

    const targetPlanner = targetDailyPlanner.find(
      (p) => p.id === Number(selectedPlanner),
    );
    const targetPackageId = targetPlanner?.parimaryPackageId;

    const result = await checkPlannerPages(newsletter?.id, targetPackageId);

    setNotMatchedCount(result?.notMatchedCount || 0);
    setNotMatchedPages(result?.notMatchedSrcPages || []);

    // Just open modal
      setShowConfirmModal(true);
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
  };

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let vessels = await getVessels();
    let data = await getTargetedSailing({
      vesselId: newsletter?.vessel_id,
      sourcePlannerID: newsletter.id,
      duration: newsletter.duration,
    });
    if (vessels.error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: vessels.error,
      });
    } else {
      setVesselOptions(vessels);
    }
    
    setTargetedDailyPlanner(data?.data);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  useEffect(() => {
    console.log({ newsletter });
  }, [newsletter]);
  useEffect(() => {
    if (newsletter) {
      getSailingDates();
      setOldSailingDate(newsletter?.sailing_date);
      setVessel_id(newsletter?.vessel_id);
    }
  }, [newsletter]);
  const getSailingDates = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getSailingDate({
      page: 1,
      limit: 2000,
      vessel_id: newsletter?.vessel_id,
    });
    setsailingOptions(data?.data);
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addNewsLetter}>
              <div style={{ padding: "10px" }} className="card-body">
                <h4 style={{ fontWeight: "bold" }}>
                  Duplicate Daily Planner Content
                </h4>
                <p>
                  {
                    vesselOptions.find(
                      (item) => item.id === newsletter?.vessel_id
                    )?.name
                  }{" "}
                  - {moment(oldsailingDate).format("DD-MMMM-YYYY")}
                </p>
              </div>
              <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                <Divider style={{ border: "1px solid gray" }} />

                <div className="row" style={{ marginTop: "20px" }}>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <h4 style={{ fontWeight: "bold" }}>Source Daily Planner</h4>
                    <p>This Daily Planner content will be copied</p>
                    <div
                      style={{
                        border: "1px solid black",
                        padding: "20px",
                        marginTop: "20px",
                        height: "200px",
                        marginBottom: "20px",
                      }}
                    >
                      <p style={{ fontWeight: "bold" }}>
                        {" "}
                        {
                          vesselOptions.find(
                            (item) => item.id == newsletter?.vessel_id
                          )?.name
                        }
                      </p>
                      <p style={{ marginBottom: "20px" }}>
                        {" "}
                        Duration: {newsletter?.duration} Days
                      </p>
                      <p> Assigned Pages: {newsletter?.page_count}</p>
                      <p> Status: {newsletter?.status}</p>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <h4 style={{ fontWeight: "bold" }}>Target Daily Planner</h4>
                    <p>Select future sailings to copy content to</p>
                    <div
                      style={{
                        border: "1px solid black",
                        padding: "20px",
                        marginTop: "20px",
                        height: "200px",
                        marginBottom: "20px",
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center"
                      }}
                    >
                      <select
                        className="form-control"
                        value={selectedPlanner}
                        onChange={e => setSelectedPlanner(e.target.value)}
                        style={{ fontSize: "16px", padding: "8px" }}
                      >
                        <option value="">Select Target Daily Planner</option>
                        {targetDailyPlanner.map(item => {
                          const rawDuration = item?.duration ?? 0;
                          const duration = Math.abs(rawDuration);
                          return (
                            <option key={item.id} value={item.id}>
                              {item.parimaryPackageId} | {moment(item?.primarySailingDate).format("DD MMM")} to {moment(item?.endDate).format("DD MMM YYYY")} / {duration} Nights
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-body">
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    padding: "10px",
                    border: "1px solid black",
                  }}
                >
                  <div style={{ flex: 1 }}>
                    <h4 style={{ fontWeight: "bold" }}>Ready to duplicate?</h4>
                    <p>
                      This will copy all calendar activities their timings and
                      dynamic content to the selected future sailings.
                    </p>
                  </div>
                  <div className=" text-right" style={{ marginLeft: "10px" }}>
                    <Button
                      type="submit"
                      variant="contained"
                      className="btn main_submit"
                      disabled={!selectedPlanner}
                    >
                      Duplicate to Daily Planner
                    </Button>
                  </div>
                </div>
              </div>
            </form>
            <FormPopup
              open={showConfirmModal}
              setOpen={setShowConfirmModal}
              width="500px"
            >
              <div style={{ textAlign: "center" }}>
                <h4 style={{ fontWeight: "bold", marginBottom: "20px" }}>
                  {notMatchedCount > 0 ? "Pages Not Available" : "Confirm Overwrite"}
                </h4>


                {/* Show this ONLY if pages are not matched */}
                {notMatchedCount > 0 && (
                  <div style={{ marginBottom: "20px", fontSize: "16px" }}>
                    <p>
                      The following {notMatchedCount} page
                      {notMatchedCount !== 1 ? "s" : ""} are not available in
                      the target sailing and cannot be duplicated:
                    </p>

                    <div
                      style={{
                        maxHeight: "150px",
                        overflowY: "auto",
                        marginTop: "10px",
                        textAlign: "left",
                        paddingLeft: "20px",
                      }}
                    >
                      {notMatchedPages.map((page, index) => (
                        <div key={page.id} style={{ marginTop: "5px" }}>
                          {index + 1}. {page.title}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Always show this warning */}
                <div style={{ marginBottom: "30px", fontSize: "15px" }}>
                  If you proceed, any existing duplicate pages in the target
                  sailing will be deleted. Do you wish to continue?
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "15px",
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={() => {
                      setShowConfirmModal(false);
                      proceedWithDuplication();
                    }}
                    style={{ backgroundColor: "#d32f2f", color: "white" }}
                  >
                    Continue Anyway
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => setShowConfirmModal(false)}
                    style={{ borderColor: "#666", color: "#666" }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </FormPopup>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default DailyPlannerDuplicateInput;
